import type { AriaRole } from 'react';
import { type ElementRef } from '../../../lib/teact/teact';

import type { IconName } from '../../../types/icons';

import buildClassName from '../../../util/buildClassName';

import styles from './Icon.module.scss';

type OwnProps = {
  name: IconName;
  className?: string;
  style?: string;
  role?: AriaRole;
  ariaLabel?: string;
  character?: string;
  hasPremiumBadge?: boolean;
  ref?: ElementRef<HTMLElement>;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
};

// v1: Premium badge overlay removed (telegram-tt rendered it via
// IconWithPremiumBadge). The `hasPremiumBadge` prop stays in OwnProps so
// ui/Button and ui/MenuItem keep compiling, but it has no effect here.
const Icon = (props: OwnProps) => renderIcon(props);

function renderIcon({
  name,
  ref,
  className,
  style,
  role,
  ariaLabel,
  character,
  onClick,
}: OwnProps) {
  return (
    <i
      ref={ref}
      className={buildClassName(`icon icon-${name}`, className)}
      style={style}
      aria-hidden={!ariaLabel}
      aria-label={ariaLabel}
      data-char={character}
      role={role}
      onClick={onClick}
    />
  );
}

export default Icon;
